<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h3.title Firmar Visita
        .columns.is-mobile
          .column.is-12-mobile.is-offset-3-tablet.is-6-tablet
            Signature(@saveFile="checkFile" v-show="verFirma")
        .columns.column-blanco
</template>

<script>
  import NavBar from './layout/NavBar'
  import Loader from '@/components/shared/Loader.vue'
  import Signature from './components/Signature'

  import { mapState } from 'vuex'
  import VisitasServices from '@/services/visitas/visitas'

  export default {
    name: 'FirmaVisita',
    components: { NavBar, Loader, Signature },
    data() {
      return {
        isLoading: false,
        w: 320,
        h: 220,
        ruta: '',
        firma: '',
        nombreFile: '',
        verFirma: true
      }
    },
    methods: {
      iniciarComponente () {
        this.nombreFile = `firma_${this.corpoVisita.id}`
      },

      checkFile (file) {
        this.firma = file
        this.isLoading = true
        if (this.firma !== 'NoData') {
          VisitasServices.firmarVisita(this.corpoVisita.id, this.firma, this.nombreFile)
            .then( data => {
              console.log(data)
              if (data.success) {
                this.displayToast('toasted-primary', data.respuesta, 'ban', 'OK')
                setTimeout(() => {
                  this.isLoading = false
                  if (this.userLogin.cargo ==='428') {
                    this.$store.commit('registrarVisitaCorpo', {})
                    this.$router.push('/Visitas/Corpo')
                  } else {
                    this.salirSistema()
                  }
                }, 1500)
              } else {
                this.isLoading = false
                this.displayToast('bubble', data.respuesta, 'ban', 'OK')
              }
            })
            .catch( e => {
              this.isLoading = false
              this.displayToast('bubble', data.respuesta, 'ban', 'OK')
            })
        } else {
          this.displayToast('bubble', 'No se encontro el archivo o no es una imagen', 'ban', 'OK')
          this.isLoading = false
        }
      },

      displayToast (tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      salirSistema () {
        sessionStorage.clear()
        this.$store.commit('setlogin', false)
        this.$store.commit('usuarioLogueado', {})
        this.$router.push('/')
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['userLogin', 'corpoVisita'])
    }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/visitas_Componentes/FirmaVisita.vue